import { render, staticRenderFns } from "./SearchPdf.vue?vue&type=template&id=1536d95e&"
import script from "./SearchPdf.vue?vue&type=script&lang=js&"
export * from "./SearchPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports